import React, { useState } from "react";
import { Typography, Box } from "@material-ui/core";
import {
  CustomButton,
  CustomCard,
  CustomPermission,
} from "../../../../../Components";
import { LinkOfferDialog } from "../LinkOfferDialog";
import { AddNewActivityModalDialog } from "../../../../../Components/V2/Header/UI/AddQuickActivityRelatedDialogs/AddNewActivityModalDialog";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "./styles";

import {
  PlusIcon,
  Sale02Icon,
  ShareIcon05,
  UserPlusIcon,
} from "../../../../../assets/icons";
import CreateLeadDialog from "../../../../../Components/CreateLeadDialog/CreateLeadDialog";
import { AfterSalePermissions } from "../../../../../Permissions";
import { PermissionDeniedLayout } from "../../../../../Layouts/PermissionDeniedLayout/PermissionDeniedLayout";

import {usePermission} from "../../../../../Hooks";

function ClientActionsCard({ contact, setRefetchOffers }) {
  const styles = useStyles();
  const { translate } = useTranslate("AfterSalesClientProfileView");
  const handleOfferDialogClose = () => {
    setIsDialogOpen((prev) => ({ ...prev, LinkOfferDialog: false }));
    setRefetchOffers((prev) => !prev);
  };
  const { isAllowed } = usePermission(Object.values(AfterSalePermissions), [
    AfterSalePermissions.LinkOffer.permissionsId,
    AfterSalePermissions.CreateLead.permissionsId,
    AfterSalePermissions.AddActivity.permissionsId,
  ]);
  const handleLeadDialogClose = (value) => {
    setIsDialogOpen((prev) => ({ ...prev, CreateNewLeadDialog: value }));
  };
  const [isDialogOpen, setIsDialogOpen] = useState({
    ActivitiesDialog: false,
    LinkOfferDialog: false,
    CreateNewLeadDialog: false,
  });

  return (
    <CustomCard classes={styles.actionsCard}>
      <Typography variant="h6" className={styles.title}>
        {translate("actions")}
      </Typography>
      <Box className={styles.actionsContainer}>
        {isAllowed ? (
          <>
            <CustomPermission
              permissionsList={Object.values(AfterSalePermissions)}
              permissionsId={AfterSalePermissions.AddActivity.permissionsId}
            >
              <CustomButton
                variant="outlined"
                color="secondary"
                className={styles.actionButton}
                startIcon={<PlusIcon width={20} height={20} />}
                onClick={() =>
                  setIsDialogOpen((prev) => ({
                    ...prev,
                    ActivitiesDialog: true,
                  }))
                }
              >
                {translate("add-activity")}
              </CustomButton>
            </CustomPermission>
            <CustomPermission
              permissionsList={Object.values(AfterSalePermissions)}
              permissionsId={AfterSalePermissions.CreateLead.permissionsId}
            >
              <CustomButton
                variant="outlined"
                color="secondary"
                className={styles.actionButton}
                startIcon={<UserPlusIcon width={20} height={20} />}
                onClick={() =>
                  setIsDialogOpen((prev) => ({
                    ...prev,
                    CreateNewLeadDialog: true,
                  }))
                }
              >
                {translate("create-lead")}
              </CustomButton>
            </CustomPermission>
            <CustomPermission
              permissionsList={Object.values(AfterSalePermissions)}
              permissionsId={AfterSalePermissions.LinkOffer.permissionsId}
            >
              <CustomButton
                variant="outlined"
                color="secondary"
                className={styles.actionButton}
                startIcon={<Sale02Icon width={20} height={20} fill={"#000"} />}
                onClick={() =>
                  setIsDialogOpen((prev) => ({
                    ...prev,
                    LinkOfferDialog: true,
                  }))
                }
              >
                {translate("link-offer")}
              </CustomButton>
            </CustomPermission>
          </>
        ) : (
          <PermissionDeniedLayout
            text={translate("necessary_permissions_to_access")}
          />
        )}

        {/* <CustomButton
          variant="outlined"
          color="secondary"
          className={styles.actionButton}
          startIcon={<ShareIcon05 width={20} height={20} fill={"#000"} />}
        >
          {translate("share-template")}
        </CustomButton> */}
      </Box>
      <LinkOfferDialog
        open={isDialogOpen.LinkOfferDialog}
        contactDetails={contact}
        onClose={handleOfferDialogClose}
      />
      {isDialogOpen.ActivitiesDialog && (
        <AddNewActivityModalDialog
          isEdit={false}
          isGeneralDialog
          activeItem={null}
          setDialogSelect={() => {}}
          DialogSelect={5}
          setisOpenDialog={setIsDialogOpen}
          onOpen={isDialogOpen.ActivitiesDialog}
          contactId={contact.id ?? ""}
          onClose={() => {
            setIsDialogOpen((item) => ({
              ...item,
              ActivitiesDialog: false,
            }));
          }}
          isAfterSales
        />
      )}
      <CreateLeadDialog
        contactId={contact.id ?? ""}
        open={isDialogOpen.CreateNewLeadDialog}
        setOpen={handleLeadDialogClose}
      />
    </CustomCard>
  );
}

export default ClientActionsCard;
